// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"a6095d40","418":"f25b6731","645":"638bb8a4","672":"f7fa927b","712":"eca78b2f","780":"d48a0d6b"}[chunkId] + ".chunk.js";
};